<div *ngIf="cardInfo" class="activity-card-meeting">
  <crm-activity-card
    [activity]="cardInfo.activity"
    [icon]="ActivityIcons[ActivityTypes.Meeting]"
    [disableCollapse]="!!(cardInfo.meetingSummaryBody || cardInfo.meetingSummaryTitle)"
  >
    <!-- Activity title -->
    <span activity-title>
      <div>
        <strong>{{ 'ACTIVITY.MEETING.TITLE' | translate }}</strong>
        @if (statusTitle$() | async; as status) {
          @if (status !== 'ACTIVITY.MEETING.STATUS_HEADER.UNKNOWN_STATUS') {
            - {{ status }}
            @if (showPrimaryAssociation()) {
              @if (primaryAssociation(); as primaryAssociation) {
                with
                <a [routerLink]="routePrefix() + '/' + primaryAssociation.linkUrl">{{ primaryAssociation.name }}</a>
              }
            }
          }
        }
      </div>
    </span>

    <!-- summary -->
    <div activity-preview>
      <!-- Primary link -->
      @if (cardInfo.processedTranscriptID) {
        <div class="link analysis-link">
          <a [href]="externalRoutePrefix() + '/meetings/meeting/' + cardInfo.processedTranscriptID"
            >{{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.VIEW_MEETING' | translate }} <mat-icon>open_in_new</mat-icon></a
          >
        </div>
      } @else if (cardInfo.activityUrl) {
        <div class="link generic-link">
          <a [href]="cardInfo.activityUrl">{{ cardInfo.activityUrlName || cardInfo.activityUrl }}</a>
        </div>
      }

      @if (cardInfo.meetingSummaryBody) {
        <div class="summarized-by-ai">
          <div class="summary-by-ai">
            <mat-icon class="ai-icon" svgIcon="galaxy-ai-icon" />
            <div>{{ 'ACTIVITY.MEETING.SUMMARY_BY_AI' | translate }}</div>
          </div>
          @if (cardInfo.meetingSummaryTitle) {
            <div class="meeting-summary-title">
              <strong><span [innerHTML]="cardInfo.meetingSummaryTitle"></span></strong>
            </div>
          }
          <div class="meeting-summary-body">
            <span [innerHTML]="cardInfo.meetingSummaryBody"></span>
          </div>
        </div>
      }
      @if (cardInfo.meetingBody) {
        <crm-activity-rich-text [richText]="cardInfo.meetingBody"></crm-activity-rich-text>
      }
      <!-- Additional content -->
      <div activity-content>
        <div class="meeting-details">
          <crm-activity-data-grid [dataItems]="activityDataItems()" [dateFormat]="dateFormat"></crm-activity-data-grid>
        </div>
      </div>
    </div>
  </crm-activity-card>
</div>
